<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-6 col-lg-5"
           v-if="year >= '2020'">

        <component :is="components.modal"
                   :name="datasetName"
                   v-model="datasetModal"
                   :module="module"
                   :sheets="sheets"
                   :surveillance="surveillance">
        </component>

        <div :class="`panel panel-${module}`">
          <div class="panel-heading">
            <div class="panel-title">
              <h3>Clôture SPIADI{{year}}</h3>
            </div>
          </div>
          <div class="panel-body">
            <component :is="components.state"
                       :year="year"
                       :step="spiadiStep">
            </component>
          </div>
          <div class="panel-footer">
            <btn type="primary" block
                 @click="showDatasetModal(`SPIADI${year}`)">
              Clôture SPIADI{{year}}
            </btn>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 col-lg-5"
           v-if="customDataset">
        <div :class="`panel panel-default`">
          <div class="panel-heading">
            <div class="panel-title">
              <h3>Données personnalisées</h3>
            </div>
          </div>
          <div class="panel-body">
            <div v-for="(d, k) in otherDatasets"
                 :key="`custom-dataset-${k}`">
              <h5>{{ d.name }}</h5>
              <p class="text-justify">
                Statut : <strong :class="`text-${d.state.style}`">{{ d.state.label }}</strong>
              </p>
              <div class="row">
                <div class="col-xs-8">
                  <btn :class="`btn-${module}`"
                       @click="showDatasetModal(d.name)" block size="sm">
                    <strong>Données «{{ d.name }}»</strong>
                  </btn>
                </div>
                <div class="col-xs-4">
                  <btn class="btn-danger"
                       @click="confirmRemoveDataset(d.name)" block size="sm">
                    <strong>Supprimer</strong>
                  </btn>
                </div>
              </div>
              <hr />
            </div>

            <p class="text-justify" v-if="datasets.others.length === 0">
              En cliquant sur le bouton ci-dessous, vous pouvez créer des
              données personnalisées qui permettront de calculer les résultats
              sur une période différente de la surveillance nationale.
            </p>

            <modal v-model="newDatasetModal">
              <div slot="title">
                  Données personnalisées
                  <span :class="`label label-${module}`">
                    {{ moduleName }}
                  </span>
              </div>
              <div class="row contact-content">
                <div class="col-xs-12">
                  <alert type="warning">
                      <p class="text-justify">
                        Merci de <strong>choisir un nom</strong>
                        pour vos «Données personnalisées».
                      </p>
                      <p class="text-justify">
                        Le nom doit respecter les règles suivantes :
                        <ul>
                          <li>
                            <strong>
                              Faire entre 8 et 64 caractères,
                            </strong>
                          </li>
                          <li>
                            <strong>
                              Contenir uniquement des lettres sans accents,
                              des chiffres, des espaces, des tirets «-» et/ou
                              des soulignés «_»,
                            </strong>
                          </li>
                          <li>
                            <strong>
                              Ne doit pas contenir le terme «spiadi» qui est
                              réservé pour les jeux de données nationaux.
                            </strong>
                          </li>
                        </ul>
                      </p>
                      <p class="text-justify" v-if="surveillance">
                        Si vous choisissez le même nom pour vos données
                        personnalisées sur plusieurs
                        modalités de surveillance
                        (<span class="label label-bactADI">Bact ADI+</span>,
                        <span class="label label-reaInfADI">Réa Inf ADI</span>,
                        etc.), les résultats seront agrégés.
                      </p>

                  </alert>
                  <div class="form-group"
                       :class="{ 'has-error': datasetNameError != null }">
                    <label for="name" class="control-label">
                      Nom du jeu de données
                    </label>
                    <input id="name"
                           class="form-control"
                           v-model.trim="datasetName"
                           type="text"
                           @blur="checkDatasetName()"
                           placeholder="«Annee 2020», «Juin-Juillet 2020», ..."/>
                    <p v-if="datasetNameError != null" class="text-danger">
                      {{ datasetNameError  }}
                    </p>
                  </div>
                </div>
              </div>
              <div slot="footer">
                <btn type="success" @click="createDataset">
                  Continuer
                </btn>
              </div>
            </modal>

            <btn type="default" block @click="newDataset">
              Nouvelles données personnalisées
            </btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import datasetModal from '@/sui/components/datasetmodal'
import datasetCauseModal from '@/sui/components/datasetcausemodal'
import datasetObs4Modal from '@/sui/components/datasetobs4modal'

import surveillanceDatasetState from '@/sui/components/surveillancedatasetstate'
import observationDatasetState from '@/sui/components/observationdatasetstate'
import causeDatasetState from '@/sui/components/causedatasetstate'

import modules from '@/sui/data/modules'
import assert from '@/sui/tools/assert'
import { confirm } from '@/sui/tools/modal'

function getCustomDatasetState (type, step) {
  assert.isString(type)
  assert(type === 'surv' || type === 'obs')
  assert.isNumber(step)

  if (type === 'surv') {
    if (step === 0) {
      return {
        label: 'fiches manquantes.',
        style: 'warning'
      }
    }

    if (step === 1) {
      return {
        label: `données d'activité manquantes.`,
        style: 'warning'
      }
    }

    assert(step === 2)
    return {
      label: 'complet.',
      style: 'success'
    }
  }

  if (type === 'obs') {
    if (step === 0) {
      return {
        label: 'fiches manquantes.',
        style: 'warning'
      }
    }

    assert(step === 1)
    return {
      label: 'complet.',
      style: 'success'
    }
  }
}

export default {
  name: 'closure',

  props: {
    surveillance: {
      type: Object
    },

    year: {
      type: String,
      required: true
    },

    module: {
      type: String,
      required: true
    },

    sheets: {
      type: Array,
      required: true
    },

    datasets: {
      type: Object,
      required: true
    },

    customDataset: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      datasetModal: false,
      newDatasetModal: false,
      datasetNameError: null,
      datasetName: null
    }
  },

  computed: {
    moduleName: function () {
      return modules[this.year][this.module].label
    },

    components: function () {
      if (this.type === 'surv') {
        return {
          modal: 'dataset-modal',
          state: 'surveillance-dataset-state'
        }
      }

      if (this.type === 'obs') {
        return {
          modal: 'dataset-observa4-modal',
          state: 'observation-dataset-state'
        }
      }

      assert(this.type === 'cause')
      return {
        modal: 'dataset-cause-modal',
        state: 'cause-dataset-state'
      }
    },

    spiadiStep: function () {
      const { spiadi } = this.datasets
      if (spiadi == null) {
        return null
      }
      return spiadi.step
    },

    otherDatasets: function () {
      const { others } = this.datasets
      assert.isArray(others)

      const result = []
      for (let i = 0; i !== others.length; ++i) {
        const dset = others[i]
        result.push(
          {
            state: getCustomDatasetState(this.type, dset.step),
            name: dset.name
          }
        )
      }

      return result
    }
  },

  methods: {
    showDatasetModal: function (name) {
      this.datasetModal = true
      this.datasetNameError = null
      this.datasetName = name
    },

    confirmRemoveDataset: function (name) {
      confirm(
        this,
        `<h3>Suppression des données «${name}»</h3>
<p class="text-justify">
  Êtes vous sûr.e de vouloir supprimer les informations concernant
  «${name}» ?
</p>
<p class="text-justify">
  <strong>
    Les fiches ne seront pas supprimées.
  </strong>
</p>
`
      ).then(() => {
        this.removeDataset(name)
      })
    },

    removeDataset: function (name) {
      const request = {
        name: name,
        year: parseInt(this.year),
        surv: this.surveillance.id,
        mod: this.module
      }

      const vm = this
      const notifyError = e => {
        vm.$notify(
          {
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant la suppression des
  données «${name}»: ${e}.`
          }
        )
      }

      this.$store.dispatch('surveillances/removeDataset', request).then(
        (r) => {
          if (r.data.err != null) {
            notifyError(r.data.err)
          }
        }
      ).catch(e => { notifyError(e) })
    },

    newDataset: function () {
      this.datasetName = ''
      this.datasetNameError = null
      this.newDatasetModal = true
    },

    checkDatasetName: function () {
      this.datasetNameError = null
      if (this.datasetName === '') {
        this.datasetNameError = 'Champs requis'
        return
      }

      if (this.datasetName.length > 64) {
        this.datasetNameError = 'Le nom ne doit pas dépasser 64 caractères'
        return
      }

      if (this.datasetName.length < 8) {
        this.datasetNameError = 'Le nom ne doit pas faire moins de 8 caractères'
        return
      }

      if (this.datasetName.toLowerCase().includes('spiadi')) {
        this.datasetNameError = 'Le nom ne doit pas contenir «spiadi»'
        return
      }

      if (!this.datasetName.match(/^[a-z\d\-_\s]+$/i)) {
        this.datasetNameError = `Le nom ne doit contenir que des lettres sans
accents, des chiffres, des espaces, des tirets et/ou des soulignés`
      }
    },

    createDataset: function () {
      this.checkDatasetName(this.datasetName)
      if (this.datasetNameError == null) {
        this.newDatasetModal = false

        setTimeout(() => { this.datasetModal = true }, 500)
      }
    }
  },

  components: {
    'dataset-modal': datasetModal,
    'dataset-observa4-modal': datasetObs4Modal,
    'dataset-cause-modal': datasetCauseModal,

    'surveillance-dataset-state': surveillanceDatasetState,
    'observation-dataset-state': observationDatasetState,
    'cause-dataset-state': causeDatasetState
  }
}
</script>
<style scoped lang="less">
.panel-title h3 {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
</style>
